import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function ProblemSection() {
  const problems = ['Usás el traductor en cada mensaje porque no tenés confianza', 'Cuando un brasileño habla rápido, cortás la conversación lo antes posible', 'No sabés cuáles son los 300 falsos amigos que te hacen quedar mal', 'Querés trabajar con empresas brasileñas pero el idioma te frena antes del primer email', 'Cada semana te decís "esta semana arranco" y no pasa nada', 'Te frustrás intentando entender audios de WhatsApp en portugués', 'Sentís que el "portuñol" ya no es suficiente para tu nivel profesional'];
  return <section className="py-20 bg-black" data-id="element-218">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-219">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-220">
          <h2 className="md:text-4xl font-extrabold text-white mb-6 text-balance text-[20px]" data-id="element-221">
            ¿Cuántas oportunidades más vas a dejar pasar por no animarte con el
            portugués?
          </h2>

          <div className="space-y-6 text-lg text-zinc-200 text-left md:text-center max-w-3xl mx-auto" data-id="element-222">
            <p className="text-[14px]" data-id="element-223">
              Tal vez ya intentaste con apps que te enseñan palabras sueltas.
              Tal vez seguiste videos de YouTube que no aplican a cómo hablamos
              nosotros. Tal vez estudiaste una semana y lo dejaste porque no
              avanzabas.
            </p>
            <p data-id="element-224">
              <strong className="text-white text-[16px]" data-id="element-225">
                No es falta de talento. Es que nadie te enseñó el sistema
                correcto para argentinos.
              </strong>
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-red-950/40 border border-red-900/60 rounded-2xl p-6 md:p-8" data-id="element-226">
          <ul className="space-y-4" data-id="element-227">
            {problems.map((problem, i) => <li key={i} className="flex items-start gap-3" data-id="element-228">
                <div className="mt-1 bg-red-500/20 p-1 rounded-full shrink-0" data-id="element-229">
                  <X className="w-4 h-4 text-red-400" data-id="element-230" />
                </div>
                <span className="text-zinc-100 font-medium text-[14px]" data-id="element-231">
                  {problem}
                </span>
              </li>)}
          </ul>
        </motion.div>

        <div className="text-center mt-12" data-id="element-232">
          <p className="font-bold text-emerald-400 text-[16px]" data-id="element-233">
            ¿Y si esta fuera la última semana que dejás pasar esta oportunidad?
          </p>
        </div>
      </div>
    </section>;
}